type Ok<T> = { ok: true; data: T };
type Err<E = Error> = { ok: false; error: E };
type Result<T, E = Error> = Ok<T> | Err<E>;
type ResultAsync<T, E = Error> = Promise<Result<T, E>>;

const ok = <T>(data: T): Ok<T> => {
  return {
    ok: true,
    data,
  };
};

const err = <E = Error>(error: E): Err<E> => {
  return { ok: false, error };
};

export { ok, err };
export type { Ok, Err, Result, ResultAsync };
